import { css } from '@emotion/react'
import { Button, Cell, DataTable, Grid, Heading, Icon, Text, Tooltip } from 'bold-ui'
import { resolveName } from 'components/form/core'
import { useForm } from 'react-final-form'
import { MetaArray } from 'util/metaPath'

import { DocumentoAssociadoFormModel } from '../types/model-cidadao'

type Item = DocumentoAssociadoFormModel

interface DocumentosAssociadosProps {
  name: MetaArray<DocumentoAssociadoFormModel>
  documentosAssociados: DocumentoAssociadoFormModel[]
}

export const DocumentosAssociados = ({ name, documentosAssociados }: DocumentosAssociadosProps) => {
  const { change } = useForm()
  const styles = createStyles()

  const handleExcluir = (row: Item) => {
    const documentosAtualizados = documentosAssociados.map((documento) =>
      documento === row ? { ...documento, stRemovido: !documento.stRemovido } : documento
    )

    change(resolveName(name), documentosAtualizados)
  }

  const renderDocumento = (row: Item) => (
    <Text style={row.stRemovido ? styles.documentoRemovido : undefined}>{row.numeroDocumento}</Text>
  )

  const renderBotaoExcluir = (row: Item) => (
    <Tooltip text={row.stRemovido ? 'Cancelar exclusão' : 'Excluir'}>
      <Button type='button' size='small' skin='ghost' onClick={() => handleExcluir(row)}>
        <Icon icon={row.stRemovido ? 'trashFilled' : 'trashOutline'} />
      </Button>
    </Tooltip>
  )

  return (
    <Grid>
      <Cell size={12}>
        <Heading level={2}>Documentos Associados</Heading>
      </Cell>
      <Cell size={8}>
        <DataTable<Item>
          columns={[
            { name: 'documento', header: 'Documento', render: renderDocumento },
            { name: 'moradores', header: '', render: renderBotaoExcluir, style: styles.colunaBotaoExcluir },
          ]}
          rows={documentosAssociados}
        />
      </Cell>
    </Grid>
  )
}

const createStyles = () => ({
  documentoRemovido: css`
    text-decoration: line-through;
  `,
  colunaBotaoExcluir: css`
    text-align: right;
  `,
})
